"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _styles = require("@mui/styles");
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactMaterialUiFormValidator = require("react-material-ui-form-validator");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles() {
  return {
    root: {
      // boxShadow: 'none',
      // backgroundColor: 'white !important'
    }
  };
};
var CustomTextArea = /*#__PURE__*/function (_Component) {
  function CustomTextArea() {
    (0, _classCallCheck2["default"])(this, CustomTextArea);
    return _callSuper(this, CustomTextArea, arguments);
  }
  (0, _inherits2["default"])(CustomTextArea, _Component);
  return (0, _createClass2["default"])(CustomTextArea, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.value !== nextProps.value) {
        return true;
      } else if (this.props.disabled !== nextProps.disabled) {
        return true;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        required = _this$props.required,
        validationRule = _this$props.validationRule,
        value = _this$props.value,
        previousValue = _this$props.previousValue,
        InputProps = _this$props.InputProps;

      //We need to pass different props to the validated text field and the previous value text field
      var validatorFieldProps = Object.assign({}, this.props);
      validatorFieldProps.classes = Object.assign({}, classes);
      validatorFieldProps.name = validatorFieldProps.name.toString();
      delete validatorFieldProps.previousValue;
      delete validatorFieldProps.validationRule;
      delete validatorFieldProps.required;
      delete validatorFieldProps.questionDescription;
      var validators = [];
      var errorMessages = [];

      /* If the field is required, add those validator rules.*/
      if (required) {
        validators.push('required');
        errorMessages.push('This field is required');
      }
      if (!(0, _lodash.isEmpty)(validationRule) && validationRule.validatorFunctionName !== null) {
        validators.push(validationRule.validatorFunctionName);
        errorMessages.push(validationRule.errorMessage);
      }
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, validators.length || !(0, _lodash.isEmpty)(InputProps) ? /*#__PURE__*/_react["default"].createElement(_reactMaterialUiFormValidator.TextValidator, (0, _extends2["default"])({
        variant: "standard",
        multiline: true,
        minRows: 3,
        maxRows: 5
      }, validatorFieldProps, {
        validators: validators,
        errorMessages: errorMessages,
        InputProps: _objectSpread({
          classes: {
            input: classes.root
          }
        }, InputProps)
      })) : /*#__PURE__*/_react["default"].createElement(_TextField["default"], (0, _extends2["default"])({
        variant: "standard",
        multiline: true,
        minRows: 3,
        maxRows: 5
      }, validatorFieldProps, {
        InputProps: {
          classes: {
            input: classes.root
          }
        }
      })), previousValue && value !== previousValue && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          color: '#207FA0',
          display: 'block'
        }
      }, "\xA0", previousValue));
    }
  }]);
}(_react.Component);
CustomTextArea.propTypes = {
  required: _propTypes["default"].bool,
  previousValue: _propTypes["default"].string,
  disabled: _propTypes["default"].bool
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(CustomTextArea);